import { useTranslations } from '@aikoa/i18n/react'
import { View } from 'react-native'
import Icon from '~/components/Icon'
import { Text } from '~/components/ui/text'
import { cn } from '~/lib/utils'

export function FeedbackRequestAcknowledgement({ className }: { className?: string }) {
  const { t } = useTranslations('feedback')

  return (
    <View className={cn('flex-row items-start gap-2', className)}>
      <Icon name="info" size={14} className="mt-0.5 text-secondary" />
      <Text className="flex-1 text-pretty font-light text-xs/normal text-secondary">
        {t(($) => $.requestFlow.contactOwnershipAcknowledgement)}
      </Text>
    </View>
  )
}
